import { PushbuttonHref } from '@stratumn/atomic';
import stratumnTriangle from 'assets/triangle.svg';
import { ROUTE_LOGIN } from 'constant/routes';
import { AUTH_PROVIDER_STRATUMN } from 'constant/types';
import compose from 'lodash.flowright';
import qs from 'query-string';
import type React from 'react';
import injectSheet from 'react-jss';
import { useLocation } from 'react-router-dom';
import styles from './oauthStratumn.style';

interface OauthStratumnProps {
  classes: Record<string, string>;
  providers?: string[] | null;
}

export const OauthStratumn: React.FC<OauthStratumnProps> = ({
  classes,
  providers
}) => {
  const location = useLocation();

  const containsProvider = (p: string) => !providers || providers.includes(p);

  const conduent =
    containsProvider(AUTH_PROVIDER_STRATUMN) &&
    (() => {
      const parsed = qs.parse(location.search);
      parsed.provider = 'stratumn';
      const search = qs.stringify(parsed);
      const href = `${ROUTE_LOGIN}${search ? `?${search}` : ''}`;

      return (
        <PushbuttonHref
          href={href}
          prefix={
            <img
              alt="Stratumn logo"
              className={classes.stratumnTriangle}
              src={stratumnTriangle}
            />
          }
          primary
        >
          Stratumn Login
        </PushbuttonHref>
      );
    })();

  return <div className={classes.oauthStratumn}>{conduent}</div>;
};

OauthStratumn.defaultProps = {
  providers: null
};

export default compose(injectSheet(styles))(OauthStratumn);
